import {designSystemToken} from '@lightricks/react-design-system';

// Helper function to create scrollbar styles
const createScrollbarStyles = (isHorizontal = false, size = 6) => ({
  '&::-webkit-scrollbar': {
    width: isHorizontal ? 'auto' : `${size}px`,
    height: isHorizontal ? `${size}px` : 'auto',
  },
  '&::-webkit-scrollbar-track': {
    background: designSystemToken('semantic.bg.tertiary'),
    borderRadius: '50px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: designSystemToken('semantic.fg.tertiary'),
    borderRadius: '50px',
  },
});

const createScrollbarHoverStyles = (isHorizontal = false, size = 6) => ({
  '&::-webkit-scrollbar': {
    width: isHorizontal ? 'auto' : `${size}px`,
    height: isHorizontal ? `${size}px` : 'auto',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'transparent',
  },
  '&:hover': {
    '&::-webkit-scrollbar-track': {
      background: designSystemToken('semantic.bg.tertiary'),
      borderRadius: '50px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: designSystemToken('semantic.fg.tertiary'),
      borderRadius: '50px',
    },
  },
});

const createScrollbarHiddenStyles = () => ({
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

// Export scrollbar mixins
// eslint-disable-next-line import/prefer-default-export
export const scrollbarMixins = {
  overrideScrollbar: createScrollbarStyles,
  overrideScrollbarHover: createScrollbarHoverStyles,
  overrideScrollbarHidden: createScrollbarHiddenStyles,
};

// Example usage:
/*
import {Box, styled} from '@mui/material';
import {scrollbarMixins} from '@/styles/mixins';

const ScrollableContainer = styled(Box)`
  height: 300px;
  overflow-y: auto;
  
  ${scrollbarMixins.overrideScrollbar()}
`;

const HoverScrollableContainer = styled(Box)`
  height: 300px;
  overflow-y: auto;
  
  ${scrollbarMixins.overrideScrollbarHover()}
`;

const HiddenScrollableContainer = styled(Box)`
  height: 300px;
  overflow-y: auto;
  
  ${scrollbarMixins.overrideScrollbarHidden()}
`;

// Or use with sx prop:
<Box
  sx={{
    height: 300,
    overflowY: 'auto',
    ...scrollbarMixins.overrideScrollbar(),
  }}
>
  Content here
</Box>
*/
